if (!customElements.get("color-swatch")) {
  class ColorSwatch extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.optionNodes = this.querySelectorAll("[data-value]");
      this.init();
    }

    disconnectedCallback() {
      this.optionNodes.forEach((button) =>
        button.removeEventListener("mouseenter", this.onMouseEnter.bind(this))
      );
    }

    init() {
      const productCard = this.closest(".product-card");
      this.mainImage = productCard.querySelector(
        ".product-card__image--main img"
      );
      this.optionNodes.forEach((button) =>
        button.addEventListener("mouseenter", this.onMouseEnter.bind(this))
      );

      this.selected = this.querySelector('a[aria-selected="true"]');

      this.getVariantData();
      this.initOptionSwatches();
      this.initSwatchOutlines();
    }

    getDefaultShadow(isWhite) {
      return isWhite ? "0 0 0 2px #777" : "0 0 0 1px #ccc";
    }

    initSwatchOutlines() {
      this.optionNodes.forEach((node) => {
        const value = (node.dataset.value || "").toLowerCase().trim();
        const isWhite = value === "white";

        node.style.setProperty("box-shadow", this.getDefaultShadow(isWhite), "important");

        node.addEventListener("mouseenter", () => {
          node.style.setProperty("box-shadow", isWhite ? "0 0 0 2px #555" : "0 0 0 2px #555", "important");
        });

        node.addEventListener("mouseleave", () => {
          if (node.getAttribute("aria-selected") === "true") {
            node.style.setProperty("box-shadow", "0 0 0 3px #333", "important");
          } else {
            node.style.setProperty("box-shadow", this.getDefaultShadow(isWhite), "important");
          }
        });
      });
    }

    initOptionSwatches() {
      this.optionNodes.forEach((optNode) => {
        let variantImage;
        const { optionPosition, value: optionValue } = optNode.dataset;
        const variant = this.variantData.find(
          (v) =>
            v[`option${optionPosition}`] &&
            v[`option${optionPosition}`].toLowerCase() ===
              optionValue.toLowerCase()
        );
        if (variant) {
          variantImage = variant.featured_image
            ? variant.featured_image.src
            : "";
          optNode.href = `${optNode.href}?variant=${variant.id}`;
          if (variantImage) {
            optNode.setAttribute(
              "data-src",
              getSizedImageUrl(variantImage, "900x")
            );
            optNode.setAttribute("data-srcset", getSrcset(variantImage));
          }
        }
      });
    }

    onMouseEnter(e) {
      const { target } = e;

      if (this.selected) {
        this.selected.removeAttribute("aria-selected");
        const wasWhite = (this.selected.dataset.value || "").toLowerCase().trim() === "white";
        this.selected.style.setProperty("box-shadow", this.getDefaultShadow(wasWhite), "important");
      }

      target.setAttribute("aria-selected", true);
      target.style.setProperty("box-shadow", "0 0 0 3px #333", "important");

      const { src, srcset } = target.dataset;
      if (this.mainImage && srcset) {
        this.mainImage.src = src;
        this.mainImage.srcset = srcset;
      }

      this.selected = target;
    }

    getVariantData() {
      this.variantData =
        this.variantData || JSON.parse(this.nextElementSibling.textContent);
    }
  }
  customElements.define("color-swatch", ColorSwatch);
}